import { render, staticRenderFns } from "./ComplementaryKits.vue?vue&type=template&id=dede21ca"
import script from "./ComplementaryKits.vue?vue&type=script&lang=js"
export * from "./ComplementaryKits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports